import {removeSiteLocaleFromPath} from '@salesforce/retail-react-app/app/utils/url';

/**
 * Path without /{site}/{locale} for use with `Link` + `buildUrl()` (same as useNavigation).
 * Repeats strip so values like /kl-ca/fr/kl-ca/checkout are normalized to /checkout.
 *
 * @param {string} path
 * @returns {string}
 */
export function toAppPathForLink(path) {
  const s = (path || '').trim();

  if (!s) return '/';
  const qIndex = s.indexOf('?');
  const pathPart = qIndex >= 0 ? s.slice(0, qIndex) : s;
  const search = qIndex >= 0 ? s.slice(qIndex) : '';
  let p = pathPart;

  for (let i = 0; i < 8; i += 1) {
    const next = removeSiteLocaleFromPath(p) || '/';

    if (next === p) {
      break;
    }
    p = next;
  }

  const withSlash = p.startsWith('/') ? p : `/${p}`;

  return withSlash + search;
}
